(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}customElements.get("atc-popup-modal")||customElements.define("atc-popup-modal",function(e){_inherits(r,e);var t=_createSuper(r);function r(){var e;return _classCallCheck(this,r),(e=t.call(this)).modalContent=e.querySelector('[id^="QuickAddInfo-"]'),e}return _createClass(r,[{key:"hide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=document.querySelector("cart-notification")||document.querySelector("cart-drawer");t&&t.setActiveElement(this.openedBy),e&&(this.openedBy=null),_get(_getPrototypeOf(r.prototype),"hide",this).call(this);}},{key:"show",value:function(e){var t=this,i=this.modalContent.querySelector("virtual-variants");i&&!i.initialized&&this.initializeVirtualVariants(i);var a=this.modalContent.querySelector("product-form");if(a&&!a.atcListenerAdded){var o=a.querySelector("form");o&&o.addEventListener("submit",(function(e){setTimeout((function(){t.handleProductAdded();}),1e3);})),a.atcListenerAdded=!0;}_get(_getPrototypeOf(r.prototype),"show",this).call(this,e);}},{key:"initializeVirtualVariants",value:function(e){var t=this.modalContent.querySelector(".product-form form"),r=this.modalContent.querySelectorAll('input[name="quantity"]');if(t&&0!==r.length){var i=e.querySelectorAll(".atc-popup__variant-option"),a=this.modalContent.querySelector(".atc-popup__product-card"),o=a&&a.querySelector("[data-atc-card-price]"),n=a&&a.querySelector("[data-atc-card-compare-price]"),c=a&&a.querySelector("[data-atc-card-unit-price]");i.forEach((function(t){t.addEventListener("click",(function(){var a=t.getAttribute("data-variant-id"),l=(e.variantData||JSON.parse(e.getAttribute("data-variants"))).find((function(e){return e.id===a}));i.forEach((function(e){e.classList.remove("atc-popup__variant-option--selected","is-active");})),t.classList.add("atc-popup__variant-option--selected","is-active"),l&&r.length>0&&r.forEach((function(e){e.value=l.quantity;})),function(e){if(e&&(o&&e.price&&(o.innerHTML=e.price),n&&(e.compare_price?(n.innerHTML=e.compare_price,n.hidden=!1):n.hidden=!0),c))if(e.unit_price){var t=c.getAttribute("data-unit-measurement")||"";c.innerHTML=t?"".concat(e.unit_price," / ").concat(t):e.unit_price,c.hidden=!1;}else c.hidden=!0;}(l);}));})),e.initialized=!0;}else console.error("ATC Popup: Product form or quantity input not found");}},{key:"handleProductAdded",value:function(){this.hide();var e=document.querySelector("cart-notification")||document.querySelector("cart-drawer");e&&"function"==typeof e.open&&e.open();}}]),r}(ModalDialog));})();